import { useState, useEffect } from 'react';
import api from '../api';

export const useColumnSettings = (pageName, defaultColumns) => {
  const [visibleColumns, setVisibleColumns] = useState(defaultColumns);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadColumnSettings = async () => {
      try {
        const response = await api.get(`/column-settings/${pageName}`);

        if (response.data.visible_columns) {
          const columns = JSON.parse(response.data.visible_columns);
          setVisibleColumns(columns);
        } else {
          // Use default columns if no settings exist
          setVisibleColumns(defaultColumns);
        }
      } catch (error) {
        console.error('Failed to load column settings:', error);
        // Fall back to default columns on error
        setVisibleColumns(defaultColumns);
      } finally {
        setLoading(false);
      }
    };

    loadColumnSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageName]);

  const isColumnVisible = (columnId) => {
    return visibleColumns.includes(columnId);
  };

  const getColumnIndex = (columnId) => {
    return visibleColumns.indexOf(columnId);
  };

  return { visibleColumns, isColumnVisible, getColumnIndex, loading };
};
